import type * as THREE from 'three';
import type {RevolveFeatureDefinitionModel} from '../../../feature/definition/revolve/RevolveFeatureDefinition';
import type {RevolveFeaturePrototype} from '../../../feature/prototype/revolve/RevolveFeaturePrototype';
import {FeaturePreviewObject} from '../FeaturePreviewObject';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/revolve 目录；
 * 2. 负责承载旋转特征预览体对象；
 * 3. 该对象直接持有 revolve prototype 与 draft definition。
 */

/**
 * 旋转预览体对象。
 */
export class BossRevolvePreviewObject extends FeaturePreviewObject<
    RevolveFeaturePrototype,
    RevolveFeatureDefinitionModel
> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: RevolveFeaturePrototype;
        draftDefinition: RevolveFeatureDefinitionModel;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
